import { Button, CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import providerPagesRoleManagement from '../../staticRoleManagement/providerRoleManagement'
import useStyles from './styles/ProviderFooter.styles'

interface ProviderFooterProps {
  isSubmitting: boolean
  loadingForMutation: boolean
}

export const ProviderFooter: React.FC<ProviderFooterProps> = ({
  isSubmitting,
  loadingForMutation
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  const hasnAccessToAddNewProvider = providerPagesRoleManagement
    .find((item) => item.route === '/provider/create')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <div className={classes.footer}>
      <Button
        disabled={isSubmitting || !hasnAccessToAddNewProvider}
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        fullWidth={matches}>
        {getTranslate('Save Provider')}
        {loadingForMutation && (
          <CircularProgress className={classes.circularProgress} size={16} />
        )}
      </Button>
    </div>
  )
}
